export default "__VITE_ASSET__5abc224e__"